import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';

function VFDSoftStarterPanel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="vfd-soft-starter-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Header */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">VFD & Soft Starter Panel</h2>
              <p className="text-muted">
                Energy-efficient motor control for industrial and commercial systems.
              </p>
              <p className="text-muted fw-semibold">APFC PANEL &nbsp; | &nbsp; ELECTRIC LOW VOLTAGE PANEL</p>
            </div>

            {/* Description */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                A VFD (Variable Frequency Drive) & Soft Starter Panel is an advanced electrical control system that regulates the speed and torque of electric motors. These panels are critical in enhancing operational control, improving system reliability, and reducing energy consumption in various applications.
              </p>
            </div>

            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src="https://www.accupanels.com/wp-content/uploads/2023/07/VFD-AND-SOFT-STARTER-PANELUse.jpg"
                  alt="APFC Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPCiPShBD0fFEoxN1SNZezJMbFAb02B4NChA&s"
                  alt="Automatic Power Factor Correction Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">Key Features</h4>
              <ul className="text-muted">
                <li><strong>Energy Efficiency:</strong> Optimizes energy use and reduces power bills.</li>
                <li><strong>Smooth Motor Operation:</strong> Prevents sudden mechanical shocks and prolongs motor lifespan.</li>
                <li><strong>Protection Features:</strong> Safeguards against voltage surges, overloads, and short circuits.</li>
                <li><strong>Improved System Reliability:</strong> Reduces operational stress on electrical and mechanical systems.</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">Benefits</h4>
              <ul className="text-muted">
                <li><strong>Reduced Power Bills:</strong> Lower energy consumption leads to significant cost savings.</li>
                <li><strong>Reduced Power Loss:</strong> Minimizes losses in conductors, transformers, and distribution systems.</li>
                <li><strong>Enhanced Equipment Life:</strong> Limits wear on motors, transformers, and control gear.</li>
                <li><strong>Stable Voltage:</strong> Helps maintain consistent voltage and improves performance.</li>
              </ul>
            </div>

            {/* Applications */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">Applications</h4>
              <ul className="text-muted">
                <li><strong>Manufacturing Plants:</strong> Controls motors, compressors, and processing equipment efficiently.</li>
                <li><strong>Commercial Buildings:</strong> Reduces operational cost in malls, offices, and complexes.</li>
                <li><strong>HVAC Systems:</strong> Increases efficiency and lifespan of fans, pumps, and chillers.</li>
              </ul>
            </div>

            {/* CTA */}
            <div className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm" data-aos="fade-up">
              <h5 className="text-dark fw-semibold">Need VFD or Soft Starter Solutions?</h5>
              <p className="mb-2 text-muted">
                Get in touch for customized motor control panels that meet your specific operational needs.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default VFDSoftStarterPanel;
